module.exports = __webpack_public_path__ + "static/media/logo_stacked_black.c94c61d2.svg";